export default __webpack_public_path__ + "media/images/react_icons/property/bed_dark-0d71771b6c0d38ba5b9649a88fbd6c0c.svg";